const TOP_TIPS_EVENT_SERIES_NAME = 'TopTipsEvent';

function getXAxisDataFromLineOption(lineOption?: IRecord | null): string[] {
  const xAxis = lineOption?.xAxis;
  if (Array.isArray(xAxis)) {
    return (xAxis[0]?.data || []).map((item: any) => String(item));
  }
  return (xAxis?.data || []).map((item: any) => String(item));
}

/**
 * 舆情 ChartsEvents 依赖 TopTipsEvent 辅助 series 做 convertToPixel 定位
 */
export function appendTopTipsEventSeries(
  lineOption?: IRecord | null,
): IRecord | null {
  if (!lineOption) return null;

  const xAxisData = getXAxisDataFromLineOption(lineOption);
  if (!xAxisData.length) return lineOption;

  const seriesList = Array.isArray(lineOption.series) ? lineOption.series : [];
  if (seriesList.some(item => item?.name === TOP_TIPS_EVENT_SERIES_NAME)) {
    return lineOption;
  }

  const anchorSeries = seriesList.find(item => item?.type === 'line') || seriesList[0];

  return {
    ...lineOption,
    series: [
      ...seriesList,
      {
        name: TOP_TIPS_EVENT_SERIES_NAME,
        type: 'line',
        data: xAxisData.map(() => 0),
        showSymbol: false,
        silent: true,
        tooltip: { show: false },
        lineStyle: { opacity: 0 },
        itemStyle: { opacity: 0 },
        emphasis: { disabled: true },
        z: -1,
        ...(anchorSeries?.xAxisIndex !== undefined
          ? { xAxisIndex: anchorSeries.xAxisIndex }
          : {}),
        ...(anchorSeries?.yAxisIndex !== undefined
          ? { yAxisIndex: anchorSeries.yAxisIndex }
          : {}),
      },
    ],
  };
}

export { TOP_TIPS_EVENT_SERIES_NAME };
